import React, { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

// WhatsApp + copy-link share control (Navy & Silver).
export default function ShareButtons({ title = "", url, testid = "share", compact = false }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const waHref = `https://wa.me/?text=${encodeURIComponent(`${title} ${shareUrl}`.trim())}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Lien copié !");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Impossible de copier le lien");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url: shareUrl }); } catch { /* cancelled */ }
    } else { copy(); }
  };

  return (
    <div className={`flex items-center gap-2 ${compact ? "" : ""}`} data-testid={`${testid}-group`}>
      <a
        href={waHref} target="_blank" rel="noreferrer" data-testid={`${testid}-whatsapp`}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] px-3.5 py-2 text-sm font-semibold text-[#ffffff] transition hover:brightness-105 active:scale-95"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.2-1.7-.9-2-1-.3-.1-.5-.1-.7.2-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-1.7-.9-2.9-1.6-4-3.5-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5 0-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.3 5.2 4.6 2 .8 2.7.9 3.7.7.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.4M12 2a10 10 0 00-8.6 15l-1.3 4.8 4.9-1.3A10 10 0 1012 2" /></svg>
        WhatsApp
      </a>
      <button
        onClick={copy} data-testid={`${testid}-copy`}
        className="inline-flex items-center gap-1.5 rounded-full border border-[#C9D2DC]/50 bg-white/5 px-3.5 py-2 text-sm font-semibold text-white transition hover:bg-white/10 active:scale-95"
      >
        {copied ? <Check size={16} className="text-emerald-400" /> : <Copy size={16} className="text-[#C9D2DC]" />}
        {compact ? "" : "Copier"}
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button onClick={nativeShare} data-testid={`${testid}-native`} className="inline-flex items-center justify-center rounded-full border border-white/15 bg-white/5 p-2 text-white/70 transition hover:bg-white/10 hover:text-white sm:hidden">
          <Share2 size={16} />
        </button>
      )}
    </div>
  );
}
